module.exports = __webpack_public_path__ + "img/1413927130.925baa6d.jpg";